module.exports = __webpack_public_path__ + "img/closeWhite.1bfbd7eb.svg";